export const sablierComptrollerAbi = [
  {
    inputs: [{ internalType: "address", name: "initialAdmin", type: "address" }],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "AccountAlreadyHasRole",
    type: "error",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "AccountDoesNotHaveRole",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "target", type: "address" }],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "admin", type: "address" },
      { internalType: "address", name: "caller", type: "address" },
    ],
    name: "CallerNotAdmin",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "implementation", type: "address" }],
    name: "ERC1967InvalidImplementation",
    type: "error",
  },
  { inputs: [], name: "ERC1967NonPayable", type: "error" },
  { inputs: [], name: "FailedCall", type: "error" },
  { inputs: [], name: "InvalidInitialization", type: "error" },
  { inputs: [], name: "NotInitializing", type: "error" },
  { inputs: [], name: "SablierComptroller_ExecutionFailedSilently", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "feeRecipient", type: "address" },
      { internalType: "address", name: "admin", type: "address" },
    ],
    name: "SablierComptroller_FeeRecipientNotAdmin",
    type: "error",
  },
  { inputs: [], name: "SablierComptroller_FeeRecipientZero", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "feeRecipient", type: "address" },
      { internalType: "uint256", name: "feeAmount", type: "uint256" },
    ],
    name: "SablierComptroller_FeeTransferFailed",
    type: "error",
  },
  {
    inputs: [
      { internalType: "uint256", name: "newFeeUSD", type: "uint256" },
      { internalType: "uint256", name: "maxFeeUSD", type: "uint256" },
    ],
    name: "SablierComptroller_MaxFeeUSDExceeded",
    type: "error",
  },
  { inputs: [], name: "UUPSUnauthorizedCallContext", type: "error" },
  {
    inputs: [{ internalType: "bytes32", name: "slot", type: "bytes32" }],
    name: "UUPSUnsupportedProxiableUUID",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "caller", type: "address" },
      { internalType: "bytes32", name: "neededRole", type: "bytes32" },
    ],
    name: "UnauthorizedAccess",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "enum ISablierComptroller.Protocol",
        name: "protocol",
        type: "uint8",
      },
      { indexed: false, internalType: "address", name: "caller", type: "address" },
      { indexed: true, internalType: "address", name: "user", type: "address" },
      { indexed: false, internalType: "uint256", name: "previousMinFeeUSD", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newMinFeeUSD", type: "uint256" },
    ],
    name: "DisableCustomFeeUSD",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "target", type: "address" },
      { indexed: false, internalType: "bytes", name: "data", type: "bytes" },
      { indexed: false, internalType: "bytes", name: "result", type: "bytes" },
    ],
    name: "Execute",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "uint64", name: "version", type: "uint64" }],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "admin", type: "address" },
      { indexed: true, internalType: "address", name: "account", type: "address" },
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "admin", type: "address" },
      { indexed: true, internalType: "address", name: "account", type: "address" },
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "enum ISablierComptroller.Protocol",
        name: "protocol",
        type: "uint8",
      },
      { indexed: false, internalType: "address", name: "caller", type: "address" },
      { indexed: true, internalType: "address", name: "user", type: "address" },
      { indexed: false, internalType: "uint256", name: "previousMinFeeUSD", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newMinFeeUSD", type: "uint256" },
    ],
    name: "SetCustomFeeUSD",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "enum ISablierComptroller.Protocol",
        name: "protocol",
        type: "uint8",
      },
      { indexed: false, internalType: "address", name: "caller", type: "address" },
      { indexed: false, internalType: "uint256", name: "previousMinFeeUSD", type: "uint256" },
      { indexed: false, internalType: "uint256", name: "newMinFeeUSD", type: "uint256" },
    ],
    name: "SetMinFeeUSD",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "admin", type: "address" },
      { indexed: false, internalType: "address", name: "previousOracle", type: "address" },
      { indexed: false, internalType: "address", name: "newOracle", type: "address" },
    ],
    name: "SetOracle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "oldAdmin", type: "address" },
      { indexed: true, internalType: "address", name: "newAdmin", type: "address" },
    ],
    name: "TransferAdmin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "feeRecipient", type: "address" },
      { indexed: false, internalType: "uint256", name: "feeAmount", type: "uint256" },
    ],
    name: "TransferFees",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: "address", name: "implementation", type: "address" }],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "FEE_COLLECTOR_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEE_MANAGEMENT_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_FEE_USD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINIMAL_INTERFACE_ID",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADE_INTERFACE_VERSION",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
    ],
    name: "calculateMinFeeWei",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
      { internalType: "address", name: "user", type: "address" },
    ],
    name: "calculateMinFeeWeiFor",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "feeUSD", type: "uint256" }],
    name: "convertUSDFeeToWei",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
      { internalType: "address", name: "user", type: "address" },
    ],
    name: "disableCustomFeeUSDFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "target", type: "address" },
      { internalType: "bytes", name: "data", type: "bytes" },
    ],
    name: "execute",
    outputs: [{ internalType: "bytes", name: "result", type: "bytes" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
    ],
    name: "getMinFeeUSD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
      { internalType: "address", name: "user", type: "address" },
    ],
    name: "getMinFeeUSDFor",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "hasRoleOrIsAdmin",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "initialAdmin", type: "address" },
      { internalType: "uint256", name: "initialAirdropMinFeeUSD", type: "uint256" },
      { internalType: "uint256", name: "initialFlowMinFeeUSD", type: "uint256" },
      { internalType: "uint256", name: "initialLockupMinFeeUSD", type: "uint256" },
      { internalType: "address", name: "initialOracle", type: "address" },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
      { internalType: "address", name: "user", type: "address" },
      { internalType: "uint256", name: "customFeeUSD", type: "uint256" },
    ],
    name: "setCustomFeeUSDFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "enum ISablierComptroller.Protocol", name: "protocol", type: "uint8" },
      { internalType: "uint256", name: "newMinFeeUSD", type: "uint256" },
    ],
    name: "setMinFeeUSD",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOracle", type: "address" }],
    name: "setOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newAdmin", type: "address" }],
    name: "transferAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "protocolAddresses", type: "address[]" },
      { internalType: "address", name: "feeRecipient", type: "address" },
    ],
    name: "transferFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "newImplementation", type: "address" },
      { internalType: "bytes", name: "data", type: "bytes" },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  { stateMutability: "payable", type: "receive" },
] as const;
